/**
 * Diode — triangle + bar (cathode on the right). LED / Zener / Schottky
 * variants share the body shape; markers deferred until the IR exposes
 * a sub-kind discriminator.
 */
import { useTheme } from "@mui/material";
import type { NodeProps } from "@xyflow/react";

import { SymbolFrame } from "./SymbolFrame";
import { SYMBOL_STROKE_WIDTH, symbolColors } from "./symbolStyle";

interface DiodeData {
  refdes?: string;
  value?: string | null;
  highlight?: boolean;
}

export function DiodeNode({ data, width, height }: NodeProps) {
  const t = useTheme();
  const { stroke } = symbolColors(t);
  const d = data as DiodeData;
  return (
    <SymbolFrame
      refdes={d.refdes}
      value={d.value}
      width={width}
      height={height}
      highlight={d.highlight}
    >
      <svg
        viewBox="0 0 56 24"
        width="56"
        height="20"
        fill="none"
        stroke={stroke}
        strokeWidth={SYMBOL_STROKE_WIDTH}
        strokeLinejoin="round"
      >
        <line x1="0" y1="12" x2="20" y2="12" />
        <polygon points="20,2 20,22 36,12" fill={stroke} />
        <line x1="36" y1="2" x2="36" y2="22" />
        <line x1="36" y1="12" x2="56" y2="12" />
      </svg>
    </SymbolFrame>
  );
}
